var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.371 18.362"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2",
    d: "M13.902 18.362a6.132 6.132 0 01-2.147-.448 19.632 19.632 0 01-3.22-1.356 19.187 19.187 0 01-3.907-3.151 21.577 21.577 0 01-2.23-2.644A13.908 13.908 0 01.613 7.047a14.82 14.82 0 01-.541-1.871 4.515 4.515 0 01.475-2.933c.075-.149.165-.29.236-.441A3.231 3.231 0 013.82.002a.622.622 0 01.619.343c.234.408.457.822.694 1.227.428.733.863 1.462 1.295 2.193l.126.216a.706.706 0 01-.088.92c-.3.31-.625.6-.946.886s-.631.546-.938.829a.63.63 0 00-.154.843c.48.807.937 1.632 1.477 2.4a12.25 12.25 0 004.1 3.585c.316.179.635.353.958.52a.577.577 0 00.728-.128c.279-.289.543-.592.812-.891.294-.327.569-.674.885-.977a.753.753 0 011.087-.106l3.286 1.9c.61.353.687.51.552 1.2-.067.341-.153.679-.238 1.016a1.918 1.918 0 01-.592.951 5.681 5.681 0 01-3.581 1.433z",
    fill: "currentColor"
  }))));
}

export default __webpack_public_path__ + "38c345360d88e8b4d2c3cf6334a6233f.svg";
export { SvgIconPhone as ReactComponent };